import { z } from "zod";
import { actorSchema, instantSchema } from "@amber/contracts";

export const platformSchema = z.string().regex(/^[a-z][a-z0-9_]*$/);
export const slugSchema = z.string().regex(/^[a-z][a-z0-9_]*$/);
export const httpUrlSchema = z.url({ protocol: /^https?$/ });
export const countSchema = z.number().int().nonnegative();

export const intervalSchema = z
  .strictObject({ from: instantSchema, to: instantSchema })
  .refine((i) => i.from < i.to, "from must be before to");
export type Interval = z.infer<typeof intervalSchema>;

export const unknownValueSchema = z.strictObject({
  state: z.literal("unknown"),
  reason: z.string().min(1),
});

export const actionNoteSchema = z.strictObject({
  by: actorSchema,
  at: instantSchema,
  reason: z.string().min(1),
});
